// extracted by mini-css-extract-plugin
module.exports = {"foundryLogo":"styles_foundryLogo__1boqM","foundryLogoImage":"styles_foundryLogoImage__3ELPS"};